import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

const AdminNav = () => {
    const { user } = useAuth();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <nav style={{
            height: isMobile ? 52 : 64,
            background: 'rgba(255,255,255,0.9)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: isMobile ? '0 12px' : '0 24px',
            position: 'sticky',
            top: 0,
            zIndex: 50,
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {isMobile && <img src="/svu-logo.png" alt="SVU" style={{ width: 24, height: 24, borderRadius: 6, objectFit: 'cover' }} />}
                <h2 style={{
                    fontSize: isMobile ? 15 : 18,
                    fontWeight: 700,
                    color: '#1e293b',
                    fontFamily: 'Outfit, sans-serif',
                    margin: 0,
                }}>Admin Panel</h2>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '5px 12px 5px 5px',
                    borderRadius: 50,
                    background: 'rgba(5,150,105,0.06)',
                    border: '1px solid rgba(5,150,105,0.1)',
                }}>
                    <div style={{
                        width: 30,
                        height: 30,
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #059669, #10b981)',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 13,
                        fontWeight: 700,
                    }}>
                        {user?.name?.charAt(0)?.toUpperCase() || 'A'}
                    </div>
                    {!isMobile && (
                        <div>
                            <div style={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}>{user?.name || 'Admin'}</div>
                            <div style={{ fontSize: 10, fontWeight: 700, color: '#059669', textTransform: 'uppercase', letterSpacing: 0.5 }}>Admin</div>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
};

export default AdminNav;
